var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-netgsm-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v("Kanal Adı")]),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.getErrorStatus("channelName"),
                    help: _vm.getErrorMessage("channelName"),
                  },
                },
                [
                  _c("a-input", {
                    ref: "channelName",
                    attrs: { placeholder: "Kanal Adı", name: "channelName" },
                    model: {
                      value: _vm.form.channelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelName", $$v)
                      },
                      expression: "form.channelName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v("Domain *")]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  name: "domain",
                  placeholder: "Örn: sip11.netsantral.com",
                },
                model: {
                  value: _vm.form.domain,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "domain", $$v)
                  },
                  expression: "form.domain",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v("WebSocket Server *")]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  placeholder: "Örn: wss://sip11.netsantral.com:8089/ws",
                  name: "websocketServer",
                },
                model: {
                  value: _vm.form.websocketServer,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "websocketServer", $$v)
                  },
                  expression: "form.websocketServer",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v("Telefon Numarası *")]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  placeholder: "Örn: 8502592789 (Başında 0 olmadan)",
                  name: "phoneNumber",
                },
                model: {
                  value: _vm.form.phoneNumber,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "phoneNumber", $$v)
                  },
                  expression: "form.phoneNumber",
                },
              }),
              _vm._v(" "),
              _c("small", { staticClass: "help-text" }, [
                _vm._v("PBX'deki numaranızı başında 0 olmadan girin"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v("API Şifresi *")]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  placeholder: "API kullanıcı şifrenizi girin",
                  name: "passwordForApi",
                  type: "password",
                },
                model: {
                  value: _vm.form.passwordForApi,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "passwordForApi", $$v)
                  },
                  expression: "form.passwordForApi",
                },
              }),
              _vm._v(" "),
              _c("small", { staticClass: "help-text" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://portal.netgsm.com.tr/webportal/abonelikislemleri/apitalep/",
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        Buradan API şifrenizi alabilirsiniz\n                    "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v("Portal Şifresi *")]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  placeholder: "Portal giriş şifrenizi girin",
                  name: "passwordForPortal",
                  type: "password",
                },
                model: {
                  value: _vm.form.passwordForPortal,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "passwordForPortal", $$v)
                  },
                  expression: "form.passwordForPortal",
                },
              }),
              _vm._v(" "),
              _c("small", { staticClass: "help-text" }, [
                _vm._v(
                  "NetGSM portal'a giriş şifreniz (API şifresinden farklıdır)"
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v("İptal"),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSubmit },
              },
              [_vm._v("\n                Bağlan\n            ")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }